import { List, Typography } from '@mui/material'
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { t } from 'i18next'
import React from 'react'
import { useColors } from '../hooks/useColors';

export function Leyenda() {

    const { getCalificationColor } = useColors()

    return (
        <List
            sx={{ maxWidth: 360, bgcolor: 'background.paper', padding: 0, fontWeight: "normal" }}
            aria-label="Leyenda Etapas"
        >
            <ListItem disablePadding>
                <ListItemText primary={
                    <>
                        <Typography variant="h6" color="text.black" fontWeight={"bold"} paddingBottom={1}>
                            {t("cuestion.tituloLeyenda")}
                        </Typography>
                        <Typography
                            fontWeight={"bold"}
                            color={
                                getCalificationColor(t("cuestion.LeyendaEtapaA"))
                            }>
                            {t("cuestion.LeyendaEtapaA")} <span style={{ color: "black", fontWeight: "normal" }}> - {t("cuestion.LeyendaTextoA")}</span>
                        </Typography>

                        <Typography
                            fontWeight={"bold"}
                            color={
                                getCalificationColor(t("cuestion.LeyendaEtapaB"))
                            }>
                            {t("cuestion.LeyendaEtapaB")} <span style={{ color: "black", fontWeight: "normal" }}> - {t("cuestion.LeyendaTextoB")}</span>
                        </Typography>

                        <Typography
                            fontWeight={"bold"}
                            color={
                                getCalificationColor(t("cuestion.LeyendaEtapaC"))
                            }>
                            {t("cuestion.LeyendaEtapaC")} <span style={{ color: "black", fontWeight: "normal" }}> - {t("cuestion.LeyendaTextoC")}</span>
                        </Typography>

                        <Typography
                            fontWeight={"bold"}
                            color={
                                getCalificationColor(t("cuestion.LeyendaEtapaD"))
                            }>
                            {t("cuestion.LeyendaEtapaD")} <span style={{ color: "black", fontWeight: "normal" }}> - {t("cuestion.LeyendaTextoD")}</span>
                        </Typography>
                    </>
                } />
            </ListItem>
        </List>
    )
}
